var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _circle, _circle2, _circle3, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 29,
    viewBox: "0 0 40 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 28,
    rx: 1.5,
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 12.5,
    x2: 14.5,
    y2: 12.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 6.5,
    x2: 16.5,
    y2: 6.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 18.5,
    x2: 14.5,
    y2: 18.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 24.5,
    x2: 35.5,
    y2: 24.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 15.5,
    x2: 13.5,
    y2: 15.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 21.5,
    x2: 13.5,
    y2: 21.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 21.5,
    x2: 35.5,
    y2: 21.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 1,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 4,
    r: 1,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 4,
    r: 1,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 4.5,
    width: 19,
    height: 14,
    rx: 0.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6255 15.636C19.6255 15.5927 19.6299 15.5623 19.6385 15.545L22.3555 6.718C22.4162 6.51867 22.5852 6.419 22.8625 6.419C23.1399 6.419 23.3132 6.51867 23.3825 6.718L26.0865 15.545C26.0865 15.5537 26.0865 15.5667 26.0865 15.584C26.0952 15.6013 26.0995 15.6143 26.0995 15.623C26.0995 15.727 26.0432 15.818 25.9305 15.896C25.8179 15.9653 25.7009 16 25.5795 16C25.4149 16 25.3065 15.9263 25.2545 15.779L24.6565 13.777H21.0555L20.4575 15.779C20.4229 15.9263 20.3102 16 20.1195 16C19.9982 16 19.8855 15.9653 19.7815 15.896C19.6775 15.8267 19.6255 15.74 19.6255 15.636ZM21.2765 13.036H24.4355L22.8625 7.797L21.2765 13.036ZM27.361 15.675V6.809C27.361 6.72233 27.3957 6.64867 27.465 6.588C27.543 6.52733 27.6384 6.497 27.751 6.497H30.052C30.8754 6.497 31.534 6.72233 32.028 7.173C32.522 7.615 32.769 8.31267 32.769 9.266V13.218C32.769 14.18 32.522 14.8863 32.028 15.337C31.534 15.779 30.8754 16 30.052 16H27.751C27.6384 16 27.543 15.9697 27.465 15.909C27.3957 15.8397 27.361 15.7617 27.361 15.675ZM28.219 15.207H30.052C30.6414 15.207 31.0964 15.0423 31.417 14.713C31.7464 14.375 31.911 13.8767 31.911 13.218V9.266C31.911 8.60733 31.7464 8.11333 31.417 7.784C31.0964 7.45467 30.6414 7.29 30.052 7.29H28.219V15.207Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdCopyIcon);
export default __webpack_public_path__ + "static/media/adCopyIcon.5b793a300e5d9cda3be01a840cb2a3f6.svg";
export { ForwardRef as ReactComponent };